import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'showTFAAuthModeField',
  initialState: false,
  reducers: {
    setShowTFAAuthModeField(state, action: PayloadAction<boolean>) {
      return action.payload;
    },
  },
});

export const { setShowTFAAuthModeField } = slice.actions;

export default slice.reducer;
